import { api } from 'app/config/apiConfig';
import { WaitingListEntry, EditWaitingListEntryData } from '../model/types';

export const updateWaitingListEntryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateWaitingListEntry: builder.mutation<WaitingListEntry, EditWaitingListEntryData>({
      query: (waitingListEntry: WaitingListEntry) => ({
        url: `/waiting-list-entry/${waitingListEntry.waitingListEntryId}`,
        method: 'PUT',
        body: waitingListEntry,
      }),
      invalidatesTags: ['Waiting list'],
    }),
  }),
});

export const { useUpdateWaitingListEntryMutation } = updateWaitingListEntryApi;
